import React from 'react';

export const CheckGray400Icon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14.5735 4.484L6.2624 12.7926C6.11129 12.9436 5.96018 13.0192 5.73351 13.0192C5.50685 13.0192 5.35574 12.9436 5.20463 12.7926L1.42686 9.01594C1.12464 8.71381 1.12464 8.26062 1.42686 7.95849C1.72908 7.65636 2.18241 7.65636 2.48464 7.95849L5.73351 11.2064L13.5157 3.42655C13.8179 3.12442 14.2713 3.12442 14.5735 3.42655C14.8757 3.72868 14.8757 4.18187 14.5735 4.484Z"
        fill="#888888"
      />
    </svg>
  );
};
